module.exports = {
  "OEbranch": "master",
  "AIBase": "zh_cn",
  "placeholder": "{%s}",
  "filePath": "/apps/mobile/src/i18n",
  "moduleName": "H5-soda-fe-soda-store-base-i18n",
  "getLangCodeString": "location.href.split('/')[3]",
  "prefix": "soda-b-i18n---",
  "noParse": true,
  "version": 851,
  "script": "//img0.didiglobal.com/static/copywriter_h5/H5-soda-fe-soda-store-base-i18n/apps/mobile/src/i18n/all.js",
  "noOmega": false
}